<div class="a11y-modal-container dynamic-html">
    <div class="a11y-modal-section" *ngFor="let section of data">
        <h4 class="section-title" *ngIf="section.title">
            {{ section.title }}
        </h4>

        <!-- Bulleted Template -->
        <ng-template #bulleted let-data>
            <ul class="list">
                <li *ngFor="let item of data" class="item-text" [innerHTML]="item.text | safeHtml"></li>
            </ul>
        </ng-template>

        <!-- Default Template -->
        <ng-template #icon let-data let-combined="combined">
            <ul class="icon-text-list">
                <li class="section-item" [ngClass]="{'combined': combined}" *ngFor="let item of data">
                    <finder-font-icon *ngIf="item.icon" class="item-icon" [ngClass]="item.class"
                        [name]="item.icon" color="{{ item.color || '' }}" [title]="item.icon" size="{{ item.size || 'm' }}">
                    </finder-font-icon>
                    <div class="item-text" [innerHTML]="item.text | safeHtml"></div>
                </li>
            </ul>
        </ng-template>

        <!-- Combined Template -->
        <ng-template #combined>
            <ng-container *ngTemplateOutlet="bulleted; context: {$implicit: section.data.bulleted}"></ng-container>
            <ng-container *ngTemplateOutlet="icon; context: {$implicit: section.data.icon, combined: true}"></ng-container>
        </ng-template>

        <div [ngSwitch]="section.variant">
            <div *ngSwitchCase="sectionVariants.bullet">
                <ng-container *ngTemplateOutlet="bulleted; context: {$implicit: section.data}"></ng-container>
            </div>
            <div *ngSwitchCase="sectionVariants.combined">
                <ng-container *ngTemplateOutlet="combined"></ng-container>
            </div>
            <div *ngSwitchDefault>
                <ng-container *ngTemplateOutlet="icon; context: {$implicit: section.data}"></ng-container>
            </div>
        </div>
    </div>
</div>
